import { Component, Input, OnDestroy, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { animate, style, transition, trigger, state } from '@angular/animations';

@Component({
  selector: 'nc-flip-text',
  templateUrl: './flip-text.component.html',
  styleUrls: ['./flip-text.component.less'],
  animations: [
    trigger('flipState', [
      state('hidden', style({
        transform: 'rotateX(-90deg) scaleY(0)',
        opacity: 0
      })),
      state('visible', style({
        transform: 'rotateX(0) scaleY(1)',
        opacity: 1
      })),
      transition('hidden => visible', animate('{{duration}}ms {{delay}}ms cubic-bezier(0.33, 1, 0.68, 1)')),
      transition('visible => hidden', animate('{{duration}}ms'))
    ])
  ]
})
export class FlipTextComponent implements OnDestroy, OnChanges {
  /** 展示的文本内容 */
  @Input() ncText: string = '';
  /** 每个字符动画持续时间 */
  @Input() ncDuration: number = 500;
  /** 每个字符之间的延迟 */
  @Input() ncDelayMultiple: number = 80;
  /** 每个字符之间的间距 */
  @Input() ncGap: number = 0;
  /** 延迟 */
  @Input() ncDelay: number = 0;
  /** 是否在视图可见时才开始动画 */
  private _startOnView: boolean = false;
  @Input()
  set ncStartOnView(val: boolean | string) {
    this._startOnView = val !== null && val !== undefined && val !== false && val !== 'false';
  }
  get ncStartOnView(): boolean {
    return this._startOnView;
  }
  /** 是否只执行一次动画 */
  private _once: boolean = false;
  @Input()
  set ncOnce(val: boolean | string) {
    this._once = val !== null && val !== undefined && val !== false && val !== 'false';
  }
  get ncOnce(): boolean {
    return this._once;
  }
  
  characters: { char: string, state: string, delay: number }[] = [];
  private observer: IntersectionObserver | null = null;
  private timeout: any = null;

  constructor(private elementRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ncText']) {
      this.start();
    }
  }

  ngOnDestroy(): void {
    this.clear();
  }

  private start(): void {
    this.clear();
    if (!this.ncStartOnView) {
      this.processText();
      this.timeout = setTimeout(() => {
        this.startAnimation();
      }, this.ncDelay);
    } else {
      this.setupIntersectionObserver();
    }
  }

  private clear(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  private setupIntersectionObserver(): void {
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.processText();
        this.timeout = setTimeout(() => {
          this.startAnimation();
        }, this.ncDelay);

        if (this.ncOnce) {
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      } else if (!this.ncOnce) {
        this.endAnimation();
      }
    },
      { threshold: 0.1 }
    );

    this.observer.observe(this.elementRef.nativeElement);
  }

  private processText(): void {
    this.characters = this.ncText.split('').map((char: string, i: number) => ({
      char,
      state: 'hidden',
      delay: i * this.ncDelayMultiple
    }));
  }

  private startAnimation(): void {
    this.characters.forEach(char => {
      char.state = 'visible';
    });
  }

  private endAnimation(): void {
    //若存在ncDelay，离开视图后，startAnimation可能还未执行，则需要清除timeout
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    //隐藏显示的文本
    this.characters.forEach(char => {
      char.state = 'hidden';
    });
  }
}
